import { useNavigation } from "@repo/core/hooks/useNavigation";
import { useNewTransactionStore } from "@repo/core/stores/newTransaction";
import { TransactionFlowType } from "@repo/core/screens/NewTransaction/types";
import { TRANSACTION_FLOWS } from "@repo/core/screens/NewTransaction/config";

export const useNewTransactionFlow = () => {
  const { replace } = useNavigation();
  const {
    flowType,
    currentRoute,
    setFlowType,
    setCurrentRoute,
    setPreviousRoute,
    setNextRoute,
    previousRoute,
    nextRoute,
    setTransactionType,
    setTransactionOperation
  } = useNewTransactionStore();

  const currentFlow = TRANSACTION_FLOWS[flowType];
  const currentRouteConfig = currentFlow.routes[currentRoute];

  const getNextRoute = () => {
    return currentRouteConfig?.next;
  };

  const getPreviousRoute = () => {
    return currentRouteConfig?.previous;
  };

  const navigateToNext = () => {
    const nextRouteFromConfig = getNextRoute();

    if (nextRoute) {
      setCurrentRoute(nextRoute);
      replace(nextRoute);
      setNextRoute(undefined);
      return;
    }

    if (nextRouteFromConfig) {
      setCurrentRoute(nextRouteFromConfig);
      replace(nextRouteFromConfig);
    }
  };

  const navigateBack = () => {
    const previousRouteFromConfig = getPreviousRoute();

    if (previousRoute) {
      setCurrentRoute(previousRoute);
      replace(previousRoute);
      setPreviousRoute(undefined);
      return;
    }

    if (previousRouteFromConfig) {
      setCurrentRoute(previousRouteFromConfig);
      replace(previousRouteFromConfig);
    }
  };

  const customNavigate = ({
    to,
    next,
    previous
  }: {
    to: string;
    next?: string;
    previous?: string;
  }) => {
    setCurrentRoute(to);
    replace(to);

    if (next) {
      setNextRoute(next);
    }
    if (previous) {
      setPreviousRoute(previous);
    }
  };

  const startNewTransactionFlow = (type: TransactionFlowType) => {
    const flow = TRANSACTION_FLOWS[type];
    setFlowType(type);
    setCurrentRoute(flow.entryPoint);
    setTransactionType(flow.transactionType);
    setTransactionOperation(flow.transactionOperation);
    replace(flow.entryPoint);
  };

  return {
    currentFlow,
    currentRoute,
    currentRouteConfig,
    flowType,
    startNewTransactionFlow,
    navigateToNext,
    navigateBack,
    customNavigate,
    getNextRoute,
    getPreviousRoute
  };
};
